import React, { useEffect, useRef, useState } from "react";
import { Typewriter } from "react-simple-typewriter";
import "./root.css";

const Root = () => {
  const typewriterRef = useRef();
  const [showDiv, setShowDiv] = useState(false);
  const [showDiv1, setShowDiv1] = useState(false);

  const handleType = (count) => {
    console.log(count);
  };

  const handleDone = () => {
    console.log(`Done after 5 loops!`);
  };

  const handleTypewriter = (text, doneTyping) => {
    if (text === "I code with React") {
      doneTyping("React", [5, 4], () => {
        typewriterRef.current.deleteAll(5, () => {
          typewriterRef.current.typeString("Typescript").start();
        });
      });
    } else if (text === "Typescript") {
      doneTyping("Typescript", [9, 4], () => {
        typewriterRef.current.deleteAll(9, () => {
          typewriterRef.current.typeString("NodeJs").start();
        });
      });
    } else if (text === "NodeJs") {
      doneTyping("NodeJs", [5, 4], () => {
        typewriterRef.current.deleteAll(5, () => {
          typewriterRef.current.typeString("Express").start();
        });
      });
    }
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowDiv1(true);
    }, 3000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowDiv(true);
    }, 10000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div className="root-container">
      <div className="container d-flex align-items-center">
        <div className=" w-100 container ">
          <div className="root-text-container rounded mb-3 ">
            <Typewriter
              className="root-text fw-bolder"
              words={[`root@michael:~$ whoami`]}
              loop={1}
              cursor
              cursorStyle="~/"
              typeSpeed={40}
              deleteSpeed={50}
              delaySpeed={1000}
              cursorColor="#fff"
            />
          </div>
          {showDiv1 && (
            <div className="root-text-container rounded">
              <Typewriter
                className="root-text fw-bolder"
                words={[
                  "Hello, Michael Here..",
                  "Frontend Dev, From Kenya! 🇰🇪",
                ]}
                loop={1}
                cursor
                cursorStyle="|"
                typeSpeed={70}
                deleteSpeed={50}
                delaySpeed={1000}
                eraseDelay={[2000, 1500, 1500, 1500]}
                cursorColor="#fff"
                onTypingDone={(text, doneTyping) => {
                  handleTypewriter(text, doneTyping);
                }}
                onLoopCallback={(loopCount) => {
                  if (loopCount === 4) {
                    return false;
                  }
                  return true;
                }}
                ref={typewriterRef}
              />
            </div>
          )}
          {showDiv && (
            <div className="root-text-container rounded mt-3">
              <div
                style={{
                  paddingTop: "0rem",
                  margin: "auto 0",
                  fontWeight: "normal",
                }}
              >
                I code with{" "}
                <span style={{ color: "#09a2ef", fontWeight: "bold" }}>
                  <Typewriter
                    words={["React", "Typescript", "NodeJs", "Express"]}
                    loop={15}
                    cursor
                    cursorStyle="_"
                    typeSpeed={100}
                    deleteSpeed={100}
                    delaySpeed={1000}
                    onLoopDone={handleDone}
                    onType={handleType}
                  />
                </span>
              </div>
            </div>
          )}
        </div>
        <div class="blob-wobble"></div>
      </div>
    </div>
  );
};

export default Root;
